import { useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";

/**
 * Modal that captures name + phone (optional message) and posts to the
 * training-ad enquiry endpoint. Rendered by TrainingAdsStrip's cards.
 */
export default function TrainingAdEnquiryModal({ open, ad, onClose }) {
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!ad?.id) return;
    if (!form.name.trim() || form.phone.replace(/\D/g, "").length < 6) {
      return toast.error("Naam aur valid phone number chahiye");
    }
    setBusy(true);
    try {
      await api.post(`/training-ads/${ad.id}/enquire`, form);
      toast.success("Enquiry sent — the academy will call you soon");
      setForm({ name: "", phone: "", message: "" });
      onClose?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Send failed");
    } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent data-testid="training-enquiry-modal" className="bg-[#0A0605] border-zinc-800 text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white">Enquire — {ad?.academy_name}</DialogTitle>
          <p className="text-xs text-zinc-400 mt-1">Aapki details academy ke pass jayengi. They'll reach out to you shortly.</p>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-zinc-300 text-xs">Your name *</Label>
            <Input data-testid="enq-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1 bg-zinc-900 border-zinc-800" required/>
          </div>
          <div>
            <Label className="text-zinc-300 text-xs">Phone (WhatsApp preferred) *</Label>
            <Input data-testid="enq-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+91 98xxxxxxxx" className="mt-1 bg-zinc-900 border-zinc-800" required/>
          </div>
          <div>
            <Label className="text-zinc-300 text-xs">Message (optional)</Label>
            <Textarea data-testid="enq-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Which course? Any timing preference?" className="mt-1 bg-zinc-900 border-zinc-800" maxLength={400}/>
          </div>
          <DialogFooter>
            <Button type="button" onClick={onClose} className="rounded-full bg-zinc-800 hover:bg-zinc-700 text-white text-sm">Cancel</Button>
            <Button data-testid="enq-submit" type="submit" disabled={busy} className="rounded-full bg-[#DC2626] hover:bg-[#EF4444] text-white font-semibold">
              {busy ? <Loader2 className="animate-spin mr-2" size={14}/> : <Send size={14} className="mr-1"/>} Send enquiry
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
